module.exports = __webpack_public_path__ + "static/media/11.1db76416.svg";